import React, { FC, useEffect } from "react";

import { closeIntroScreen } from "../../features/chatbot/chatbotSlice";

import styles from "./ChatFrame.module.css";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import IntroScreen from "../IntroScreen/IntroScreen";
import { generateQueryString } from "../../utils/queryString";
import ChatContainer from "../ChatContainer/ChatContainer";
import { setUserQuestion } from "../../features/chatConfig/chatConfigSlice";

const ChatFrame: FC = () => {
  const dispatch = useAppDispatch();

  // Functions

  // State Selectors
  const { isInitialized, isIntroScreenClosed } = useAppSelector((state) => state.chatbot);
  const { chatMode, jevaMode } = useAppSelector((state) => state.chatConfig);
  const { introScreen } = useAppSelector((state) => state.chatConfig.chatConfig!.config.queue1);
  const chatConfig = useAppSelector((state) => state.chatConfig);
  useEffect(() => {
    Object.defineProperty(window, "onIntroClose", {
      value: (userQuestion: string | null) => {
        if (userQuestion) {
          dispatch(setUserQuestion(userQuestion));
        }
        dispatch(closeIntroScreen());
      },
      configurable: true,
    });
  }, [dispatch]);

  return (
    <ChatContainer>
      {introScreen && !isIntroScreenClosed ? (
        <IntroScreen widgetId={introScreen} />
      ) : isInitialized ? (
        <div className={`${styles.chat_body} ${(chatMode === "VOICE" && jevaMode !== "action") || jevaMode === "video_call" ? styles.voice_only : ""}`}>
          <iframe name="CONVERSATION_FRAME" title="CONVERSATION_FRAME" allow="camera *;microphone *;display-capture *;clipboard-write *;autoplay *;" src={`${window.__PATH__?.appUrls.jeva}?${generateQueryString(chatConfig)}`} />
        </div>
      ) : null}
    </ChatContainer>
  );
};

export default ChatFrame;
